export default {
  min: 100,
  max: 1000,
  rewards: {
    min: 100,
    max: 50000
  }
};
